import { useEffect, useRef } from "react";

const services = [
  {
    icon: "ri-flashlight-line",
    title: "Realtime Systems",
    description:
      "Performance-critical software, multithreaded programming, memory optimization, and network programming.",
  },
  {
    icon: "ri-server-line",
    title: "Backend",
    description:
      "Online services, orchestration, and application integration.",
  },
  {
    icon: "ri-tools-line",
    title: "Tools",
    description:
      "Developer tooling, local environments, containerization, deployment pipelines, and integration workflows.",
  },
  {
    icon: "ri-gamepad-line",
    title: "Games",
    description:
      "Networked synchronization, gameplay services, deterministic and nondeterministic simulations, and client/server or peer-to-peer architectures.",
  },
];

export default function Services() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll(".reveal");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="services"
      ref={sectionRef}
      className="relative py-24 md:py-32 px-4 md:px-8 lg:px-16"
    >
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="mb-16 md:mb-20">
          <p className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out text-ding-phosphor font-mono text-sm tracking-widest uppercase mb-4">
            &gt; services
          </p>
          <h2 className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-100 text-3xl md:text-4xl lg:text-5xl font-bold font-mono text-ding-cream mb-6">
            What we build
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="reveal opacity-0 translate-y-6 transition-all ease-out group p-6 md:p-8 rounded-xl bg-ding-dark border border-ding-lightgray hover:border-ding-phosphor duration-300"
              style={{ transitionDelay: `${300 + index * 100}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center mb-5">
                <i
                  className={`${service.icon} text-2xl text-ding-phosphor`}
                ></i>
              </div>
              <h3 className="text-lg font-semibold font-mono text-ding-cream mb-3 group-hover:text-ding-phosphor transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-sm text-ding-dim leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}